import { GenIcon } from 'react-icons';
export const MdHome2Filled = GenIcon({
    tag: 'svg',
    attr: { fill: 'none' },
    child: [
        {
            tag: 'svg',
            attr: { fill: 'none' },
            child: [
                {
                    tag: 'path',
                    attr: {
                        fillRule: 'evenodd',
                        clipRule: 'evenodd',
                        d: 'M12 3 2 12h3v8h14v-8h3L12 3ZM9.852 15.38a8.463 8.463 0 0 1-.33.271v1.381h5.354v-1.51h-2.88c.804-.631 1.465-1.276 1.984-1.936.52-.666.779-1.387.779-2.163 0-.71-.217-1.286-.651-1.728-.427-.442-1.063-.663-1.91-.663-.49 0-.938.098-1.343.293-.399.196-.722.5-.971.914-.242.412-.37.927-.384 1.543h1.76c0-.377.075-.667.224-.87a.755.755 0 0 1 .64-.315c.27 0 .473.084.608.25.135.167.203.399.203.696 0 .391-.139.793-.416 1.206a6.809 6.809 0 0 1-1.024 1.185c-.399.377-.946.859-1.643 1.446Z',
                        fill: 'currentColor',
                    },
                    child: [],
                },
            ],
        },
    ],
});
